<!-- savePereferences modal -->
<section class="modal modal--savePereferences modal--{{modalData.type}}">
  <div class="modal-dialog w-500">
    <div class="modal-content">
      <div class="modal-body">

        <div class="message margin-bottom-8 text-danger">{{appCopy.panelHeader['preferenceMsg'+selectedLanguage]}}</div>

        <h4 class="modal-title margin-bottom-24" *ngIf="!isChangePreferences && !isEditPreferences">
          {{appCopy.panelHeader['confirmPreferenceTitle'+selectedLanguage]}}</h4>
        <h4 class="modal-title margin-bottom-24" *ngIf="isEditPreferences">
          {{appCopy.panelHeader['editPreferenceTitle'+selectedLanguage]}}</h4>
        <h4 class="modal-title margin-bottom-24" *ngIf="isChangePreferences">
          {{appCopy.panelHeader['changePreferenceTitle'+selectedLanguage]}}</h4>

        <!-- OTP section here -->
        <div *ngIf="isEditPreferences" class='otp-section'>

          <p class='otp-content'
            [innerHtml]="appCopy.panelHeader['otpContent'+selectedLanguage].replace('%s', currentUserEmail)">We sent
            you an email with a One Time Password (OTP) to {{currentUserEmail}}.
            Please enter the code below to modify your communication preferences.</p>

          <div class="row">
            <div class="col-sm-8">
              <div class="form-group margin-bottom-0">
                <input class="form-control" type="text" [maxLength]="6"
                  [ngClass]="{ 'has-error' : otp.invalid && otp.dirty }" id="otp" name="otp" #otp="ngModel" ngModel
                  alert-caps-lock appCheckEmpty (keyup.enter)="inlineOTPLogin(bookerData.emailAddress, otp.value)"
                  [pattern]="otpPattern" inputmode="numeric">
                <label class="control-label"
                  for="otp">{{appCopy.panelHeader['OTPPlaceholder'+selectedLanguage]}}</label>
                <i class="icon control-validation-state"></i>
              </div>
            </div>
            <div class="col-sm-4">
              <button [ngClass]="{'Buttonloading' : showLoginLoader || showOTPLoader }"
                class="btn btn-primary btn-lg btn-block" type="button"
                (click)="inlineOTPLogin(bookerData.emailAddress, otp.value)"
                [disabled]="!otp || showOTPLoader || showLoginLoader || otp?.errors?.pattern">
                <span *ngIf="!showLoginLoader">{{appCopy.panelHeader['buttonSubmit'+selectedLanguage]}}</span>
              </button>
            </div>
            <div *ngIf="!OTPLimitReached" class="col-lg-12 col-md-12">
              <button (click)="sendOTP($event)" class="btn btn-text-ghost" [disabled]="
                      isCounting || showOTPLoader
                    ">
                {{ isCounting ? appCopy.panelHeader['resendInSecText'+selectedLanguage].replace('%s', countdown) :
                appCopy.panelHeader['resendOTPButton'+selectedLanguage] }}
                <div *ngIf="showOTPLoader" class="loader-container-btn">
                  <div class="loader loader--gray">
                    <svg class="circular" viewBox="25 25 50 50">
                      <circle class="path" cx="50" cy="50" r="20" />
                    </svg>
                  </div>
                </div>
              </button>
            </div>
          </div>

        </div>
        <!-- OTP section ends here -->

        <form #form="ngForm" name="formBooker" (ngSubmit)="handleSavePreferencesSubmit()" novalidate>

          <div class="flex gap-12 margin-bottom-24" *ngIf="!isChangePreferences">
            <img class='no-service-img' width="20" src="../../../../../images/email-icon.svg"
              alt="no service available">
            <p class="text-dark-blue readOnlyData">
              {{currentUserEmail}}
            </p>
          </div>

          <div class="form-group" *ngIf="isChangePreferences">
            <input class="form-control"
              [ngClass]="{ 'has-error' : bookerEmail.dirty && bookerEmail.invalid || bookerEmail.dirty && bookerEmail.errors?.pattern || bookerEmail.errors?.incorrect }"
              id="bookerEmail" name="bookerEmail" type="email" #bookerEmail="ngModel" [pattern]="emailPattern"
              [(ngModel)]="bookerData.emailAddress" autocomplete="off" required appCheckEmpty>
            <label class="control-label"
              for="bookerEmail">{{appCopy.panelHeader['bookerEmailLabel'+selectedLanguage]}}</label>
            <i class="icon control-validation-state"></i>

            <p class="help-block text-danger"
              *ngIf="bookerEmail.dirty && bookerEmail.invalid && !bookerEmail.errors?.pattern || bookerEmail.errors?.incorrect">
              {{appCopy.panelHeader['errorTextBookerEmailRequired'+selectedLanguage]}}</p>
            <p class="help-block text-danger" *ngIf="bookerEmail.dirty && bookerEmail.errors?.pattern">
              {{appCopy.panelHeader['errorTextBookerEmailInvalid'+selectedLanguage]}}</p>
          </div>
          <!--
          <div *ngIf="isChangePreferences && showhasMarketingCheck"
            class="checkbox checkbox--default checkbox--small checkbox--reverse margin-bottom-16 hasNotEmailMarketingEnrolment">
            <input type="checkbox" checked="true" name="hasNotEmailMarketingEnrolment"
              id="hasNotEmailMarketingEnrolment" #HasNotEmailMarketingEnrolment="ngModel"
              [(ngModel)]='bookerData.hasNotEmailMarketingEnrolment' [disabled]="!isChangePreferences">
            <label for="hasNotEmailMarketingEnrolment" class="text-caption">
              <span>
                <b>{{appCopy.panelHeader['optOutMarketingEnrolmentCheckLabel'+selectedLanguage]}}</b>
              </span>
            </label>
          </div> -->

          <div class="flex gap-12 margin-bottom-24" *ngIf="!isChangePreferences">
            <img class='no-service-img' width="20" src="../../../../../images/phone-icon.svg"
              alt="no service available">
            <p class="text-dark-blue readOnlyData" >
              +{{currentUsercountryCode}} {{currentUserPhoneNumber}}
            </p>
          </div>

          <div class="row" *ngIf="isChangePreferences">
            <div class="multiple-inputs clearfix">
              <div class="col-xs-12 flex">
                <div class="form-group with-select">
                  <div class="with-select__custom-value">+{{contactCountryCode.value}}</div>
                  <ng-select class="form-control form-control--no-label"
                    [ngClass]="{ 'has-error' : contactPhone.errors?.incorrect || contactPhone.invalid && contactPhone.dirty }"
                    id="contactCountryCode" name="contactCountryCode" #contactCountryCode="ngModel"
                    [(ngModel)]="bookerData.countryCode"
                    (ngModelChange)="validatePhoneNumber($event, contactPhone.value)" [clearable]="false"
                    [items]="countryCodes.all"
                    [notFoundText]="appCopy.panelHeader['bookerCountryNotFound'+selectedLanguage]" groupBy="label"
                    bindLabel="displayText" bindValue="countryCode">
                  </ng-select>
                </div>
                <div class="form-group flex-1">
                  <input class="form-control form-control--no-label"
                    inputmode="numeric"
                    [pattern]="'^[0-9]*$'"
                    (keypress)="allowOnlyNumbers($event)"
                    [ngClass]="{ 'has-error' : contactPhone.invalid && contactPhone.dirty || contactPhone.errors?.incorrect || contactPhone.errors?.pattern }"
                    type="number" id="contactPhone" name="contactPhone" #contactPhone="ngModel"
                    placeholder="{{appCopy.panelHeader['contactPlaceholder'+selectedLanguage]}}"
                    [(ngModel)]="bookerData.phoneNumber"
                    (ngModelChange)="validatePhoneNumber(contactCountryCode.value, contactPhone.value)"
                    (blur)="validatePhoneNumber(contactCountryCode.value, contactPhone.value)" required appCheckEmpty>
                  <i class="icon control-validation-state"></i>

                </div>
              </div>
              <div class="col-xs-12">
                <p class="help-block text-danger"
                  *ngIf="contactPhone.invalid && contactPhone.dirty || contactPhone.errors?.incorrect">
                  {{appCopy.panelHeader['errorTextContact'+selectedLanguage]}}</p>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-sm-12 margin-bottom-16" *ngIf="!isChangePreferences && !isEditPreferences">
              <button (click)='confirm($event)' class="btn btn-primary btn-lg btn-block">
                {{appCopy.panelHeader['confirmPreferenceButton'+selectedLanguage]}}
              </button>
            </div>

            <div class="col-sm-12 margin-bottom-16" *ngIf="!isChangePreferences && !isEditPreferences">
              <button (click)='editPreferences($event)' class="btn btn-ghost btn-lg btn-block">
                {{appCopy.panelHeader['editPreferenceButton'+selectedLanguage]}}
              </button>
            </div>

            <div class="col-sm-12 margin-bottom-16" *ngIf="isChangePreferences">
              <button [ngClass]="{'Buttonloading' : savePreferenceLoader }"
                [disabled]="form.invalid || savePreferenceLoader || !phoneNumberValid" type="submit"
                class="btn btn-primary btn-lg btn-block">
                {{bookerData.emailAddress !== currentUserEmail ?
                appCopy.panelHeader['saveAndResendConfirmationEmail'+selectedLanguage] :
                appCopy.panelHeader['savePreferences'+selectedLanguage] }}
              </button>
            </div>

            <div class="col-sm-12" *ngIf="isChangePreferences || isEditPreferences">
              <button (click)='canelEditCommunicationPreferences($event)' class="btn btn-ghost btn-lg btn-block">
                {{appCopy.panelHeader['alertCancelButton'+selectedLanguage]}}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
